import store from '@/store'
import { sanitizeCardDescription } from '@/utils/sanitize'

export const workflowHelpers = {
  methods: {
    getSystemGroupedBy (rootEntity, entityCard) {
      if (!entityCard) {
        return null
      }

      return {
        type: rootEntity ? 'linked-entity' : 'unlinked-text',
        rootEntity,
        text: rootEntity ? rootEntity.name : sanitizeCardDescription(entityCard.description || ''),
        boundedContext: rootEntity ? rootEntity.boundedContext : entityCard?.boundedContext
      }
    },
    getEntityFieldRefMap (entity) {
      const fieldRefMap = new Map()
      for (const field of entity.fields || []) {
        if (field.relatedEntityId) {
          fieldRefMap.set(field.name.toLowerCase(), field.relatedEntityId)
        }
      }

      return fieldRefMap
    },
    async deleteCardTypes (cardTypes) {
      await Promise.all(cardTypes.map(async (ct) => {
        return await this.$store.dispatch('cardTypes/deleteCardType', { id: ct.id, workflowId: this.workflow.id })
      }))
    }
  },
  computed: {
    workflowStatusCompleted () {
      return this.workflow?.status === 2 || store.state.payments.subscriptionAccessType !== 'FULL'
    }
  }
}
